import { graphql } from '@guuru/graphql-common/gql';
import { CHAT_MESSAGE_FIELDS as MessageFields } from '@guuru/graphql-web';

export default graphql(
  `
    subscription NewChatMessage(
      $id: ID!
      $forExpert: Boolean
      $forUser: Boolean
    ) {
      newChatMessage(id: $id, forExpert: $forExpert, forUser: $forUser) {
        ...MessageFields
      }
    }
  `,
  [MessageFields],
);
